<template>
  <div class="fixed top-5 right-5 z-[10000] flex flex-col gap-3 max-w-md pointer-events-none">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="[
          'flex items-center gap-3 px-4 py-3 rounded-lg shadow-xl backdrop-blur-sm border pointer-events-auto',
          'transition-all duration-300 ease-in-out',
          toastClasses[toast.type]
        ]"
      >
        <i :class="['text-lg flex-shrink-0', toastIcons[toast.type]]" />
        <span class="flex-1 text-sm font-medium">{{ toast.message }}</span>
        <button
          @click="remove(toast.id)"
          class="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded hover:bg-white/20 transition-colors"
          aria-label="Close"
        >
          <i class="fas fa-times text-xs" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { toasts, remove } = useToast()

const toastClasses = {
  success: 'bg-green-600/95 text-white border-green-500/50',
  error: 'bg-red-600/95 text-white border-red-500/50',
  warning: 'bg-orange-600/95 text-white border-orange-500/50',
  info: 'bg-blue-600/95 text-white border-blue-500/50'
}

const toastIcons = {
  success: 'fas fa-check-circle',
  error: 'fas fa-exclamation-circle',
  warning: 'fas fa-exclamation-triangle',
  info: 'fas fa-info-circle'
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100px) scale(0.8);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>
